<template>
    <Modal2
        v-if="visible"
        design="v3"
        :show-title="false"
        :show-footer="false"
        class-name="filter-name-modal"
        @cancel="handleCancel"
    >
        <div class="filter-name-modal-wrapper">
            <div class="filter-name-modal-title">
                <i class="material-icons">edit</i>
                <span>{{ $t("auto.filterName") }}</span>
            </div>
            <div class="filter-name-modal-content">
            <p>{{ $t("auto.pleaseEnterFilterName") }}</p>
            <input
                ref="filterNameInput"
                class="filter-name-input-modal"
                type="text"
                v-model="localFilterName"
                @keyup.enter="handleConfirm"
                @input="handleInput"
                @blur="handleBlur"
                :placeholder="$t('auto.enterFilterName')"
            />
            <label class="filter-description-label">{{ $t("chat.filterPanel.filterDescriptionLabel") }}</label>
            <textarea
                class="filter-description-textarea"
                v-model="localDescription"
                rows="4"
                :placeholder="$t('chat.filterPanel.filterDescriptionPlaceholder')"
            ></textarea>
            <div v-if="error" class="filter-name-error">
                {{ error }}
            </div>
            <div v-if="suggestedName && suggestedName !== localFilterName" class="filter-name-info">
                <i class="material-icons">info</i>
                <span>{{ $t("auto.nameAlreadyInUseFilterWillBeCreatedAs", { name: suggestedName }) }}</span>
            </div>
            <div class="filter-name-modal-footer">
                <SupsisButton @click="handleCancel">
                    {{ $t("auto.cancel") }}
                </SupsisButton>
                <SupsisButton primary @click="handleConfirm" :disabled="!localFilterName || !localFilterName.trim()">
                    {{ $t("auto.save") }}
                </SupsisButton>
            </div>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from "@/components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "FilterNameModal",
    components: {
        Modal2,
        SupsisButton,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        filterName: {
            type: String,
            default: "",
        },
        filterDescription: {
            type: String,
            default: "",
        },
        suggestedName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            localFilterName: "",
            localDescription: "",
            error: "",
            inputTimeout: null,
        };
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.localFilterName = this.filterName || "";
                this.localDescription = this.filterDescription || "";
                this.error = "";
                this.$nextTick(() => {
                    if (this.$refs.filterNameInput) {
                        this.$refs.filterNameInput.focus();
                    }
                });
            }
        },
        filterName(newVal) {
            if (this.visible) {
                this.localFilterName = newVal || "";
            }
        },
        filterDescription(newVal) {
            if (this.visible) {
                this.localDescription = newVal || "";
            }
        },
    },
    methods: {
        handleInput() {
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout);
            }
            this.inputTimeout = setTimeout(() => {
                this.updateSuggestedName();
            }, 1000);
        },
        handleBlur() {
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout);
            }
            this.updateSuggestedName();
        },
        updateSuggestedName() {
            if (this.localFilterName && this.localFilterName.trim()) {
                this.$emit("update-suggested-name", this.localFilterName.trim());
            } else {
                this.$emit("update-suggested-name", "");
            }
        },
        handleConfirm() {
            if (!this.localFilterName || !this.localFilterName.trim()) {
                this.error = "Lütfen bir filtre adı girin";
                return;
            }

            this.error = "";
            this.$emit("confirm", {
                name: this.localFilterName.trim(),
                description: this.localDescription ? this.localDescription.trim() : "",
            });
        },
        handleCancel() {
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout);
            }
            this.error = "";
            this.$emit("cancel");
        },
    },
    beforeDestroy() {
        if (this.inputTimeout) {
            clearTimeout(this.inputTimeout);
        }
    },
};
</script>

<style lang="scss" scoped>
.filter-name-modal {
    .filter-name-modal-wrapper {
        display: flex;
        flex-direction: column;
    }

    .filter-name-modal-title {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 18px;
        font-weight: 600;
        color: #22272d;
        padding: 20px;
        border-bottom: 1px solid #e5e7eb;

        .material-icons {
            font-size: 24px;
            color: #667eea;
        }
    }

    .filter-name-modal-content {
        padding: 20px;

        p {
            font-size: 14px;
            color: #6b7785;
            line-height: 1.6;
            margin-bottom: 16px;
        }

        .filter-description-label {
            display: block;
            margin-top: 16px;
            margin-bottom: 8px;
            font-size: 13px;
            font-weight: 600;
            color: #374151;
        }

        .filter-description-textarea {
            width: 100%;
            min-height: 88px;
            padding: 10px 12px;
            border: 2px solid #e5e7eb;
            border-radius: 6px;
            font-size: 14px;
            color: #22272d;
            background: #fff;
            outline: none;
            resize: vertical;
            line-height: 1.5;

            &:focus {
                border-color: #667eea;
            }

            &::placeholder {
                color: #bfbfbf;
            }
        }

        .filter-name-input-modal {
            width: 100%;
            height: 40px;
            padding: 0 12px;
            border: 2px solid #e5e7eb;
            border-radius: 6px;
            font-size: 14px;
            color: #22272d;
            background: #fff;
            outline: none;
            transition: border-color 0.2s ease;

            &:focus {
                border-color: #667eea;
            }

            &::placeholder {
                color: #bfbfbf;
            }
        }

        .filter-name-error {
            margin-top: 8px;
            color: #ef4444;
            font-size: 13px;
        }

        .filter-name-info {
            display: flex;
            align-items: flex-start;
            gap: 8px;
            margin-top: 12px;
            padding: 12px;
            background: #f0f7ff;
            border: 1px solid #b3d9ff;
            border-radius: 6px;
            font-size: 13px;
            color: #0066cc;
            line-height: 1.5;

            .material-icons {
                font-size: 18px;
                color: #0066cc;
                flex-shrink: 0;
                margin-top: 1px;
            }

            strong {
                font-weight: 600;
            }
        }
    }

    .filter-name-modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
    }
}
</style>

